var map = {
	"./business-hour-black.svg": "a6bb",
	"./email-black.svg": "0e52",
	"./events-black.svg": "08d0",
	"./general-black.svg": "8b01",
	"./iot-black.svg": "7f31",
	"./operator-app-black.svg": "9891",
	"./payments-black.svg": "23dd",
	"./point-black.svg": "815e",
	"./profile-black.svg": "616f",
	"./quiz-black.svg": "f868",
	"./rent-black.svg": "afcc",
	"./rider-app-black.svg": "1195",
	"./security-black.svg": "2f31",
	"./trip-black.svg": "8576",
	"./vehicle-black.svg": "e678"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e16d";